import { store } from "rfx-core";

import AppStore from "./modules/principal/stores/AppStore";
import ModalStore from "./modules/comum/stores/ModalStore";
import TabelaStore from "./modules/comum/stores/TabelaStore";
import FormStore from "./modules/comum/stores/FormStore";
import LoginStore from "./modules/login/stores/LoginStore";
import ValidacaoStore from "./modules/comum/stores/ValidacaoStore";
import TituloPaginaStore from "./modules/comum/stores/TituloPaginaStore";
import LoadingPanelStore from "./modules/comum/stores/LoadingPanelStore";

export default store.setup({
	appStore: AppStore,
	modalStore: ModalStore,
    formStore: FormStore,
	tabelaStore: TabelaStore,
	loginStore: LoginStore,
	validacaoStore: ValidacaoStore,
    tituloPaginaStore: TituloPaginaStore,
    loadingPanelStore: LoadingPanelStore
});